const MarkElem = ['mark', 'span'];

export { MarkElem };
